<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const title = field<string>("title", "New Tab");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:panel-top-dashed" accent="container">
    <EditorField :label="t('titleLabel')">
      <Input v-model="title" class="h-8 rounded-sm bg-muted text-[13px]" :placeholder="t('titlePlaceholder')" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Tab Item"
  titleLabel: "Title"
  titlePlaceholder: "Tab item title"
</i18n>
